export default __webpack_public_path__ + "a1e9b1d48a809dfc5dc6cdf5b5b3a532.svg";